import React from 'react';
import EmojiFrequentIcon from '@atlaskit/icon/glyph/emoji/frequent';
import { N600 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var IconContainer = styled.span({
  marginLeft: "var(--ds-space-negative-025, -2px)",
  marginTop: "var(--ds-space-025, 2px)"
});
export var DefaultIcon = function DefaultIcon() {
  return /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(EmojiFrequentIcon, {
    primaryColor: "var(--ds-icon-accent-gray, ".concat(N600, ")"),
    size: "medium",
    label: "recent-search"
  }));
};